module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "lxm-login__logo-text"
  }, [_vm._v("每个智慧公益背后都有灵析")]), _vm._v(" "), _c('div', {
    staticClass: "lxm-login__container"
  }, [_c('phone-verification', {
    attrs: {
      "smsTime": _vm.state.time.login,
      "phoneInputName": "请输入您的手机号"
    },
    on: {
      "rqst-sms": _vm.rqstSms
    }
  }), _vm._v(" "), _c('button-primary', {
    staticClass: "lxm-login-login__primary-button",
    attrs: {
      "text": '登录',
      "loading": _vm.buttonLoading,
      "disabled": _vm.buttonDisabled
    },
    on: {
      "click": _vm.clicked
    }
  }), _vm._v(" "), _c('other-button', {
    attrs: {
      "needPhone": false
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-login__logo"
  }, [_c('img', {
    attrs: {
      "src": "https://s.lingxi360.com/register/%E7%BC%96%E7%BB%84%402x.png"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-75865051", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75865051!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/Login.vue
// module id = 870
// module chunks = 0